import React,{useState, useEffect}  from 'react';
import { Card } from 'react-bootstrap'
import { Helmet } from "react-helmet";
import Sides from '../Bars/Diffjvscs';
import Button from 'react-bootstrap/Button'


function Difference_Bw_Java_and_Csharp() {
 
  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  


  return (
    <div>
     <Sides />
      <Helmet>

        <title>Difference Between Java and CSharp(C#) Basic tutorial For Beginners</title>
        <meta name="description" content="Difference Between Java and Csharp(C#) Basic tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, java tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
        <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Difference Between Java and Csharp(C#),Difference between program and code,java tutorial for begineers,C# tutorial for begineers,java tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs c#,java vs Python,Basic Programming Tutorial For Begineers" />
        <link rel="canonical" href="https://www.codeexampler.com/java-vs-csharp-basic" />
      </Helmet>
<div className='lg:pl-56'>
      <h1 className="m-4 mh1">Java vs C# basic</h1>
      <div className="first">

      <a href="/java-vs-csharp-if"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>

      </div>
      <h2 className="mt-4 mh2">
Java Basic Programme Steps</h2>
      <p className="mt-4 para"> 1, Firstly the name of the source file should be an: <span className="bold">basis_example.java</span><br />
 2, The Java compiler requires that the source file use.Java filename extension. <br />
 3, After going inside the program <br />
 4, Write a class keyword to declare a new class <br />
 5, Basis_example is an identifier  and also this is the name of class<br />
 6, Inside this class, we create a body between the opening curly braces( &#123; ) and close by curly braces( &#125; ).<br />
 7, This is a very important line in the java program <br />
        <span className="bold">Public static void main(string  args[]) </span><br />
8, The public is access –modifier keyword. The public allows the program to access the visibility of class members.<br />
9, Static is also a keyword .static keyword by the use of JVM call  directly main () method without creating any object  means no need to create an object<br />
10, Void this is also a keyword and role of the void  is that compile the main() without return a value<br />
        <span className="bold">Main()</span> <br />
*This is a pre-defined method.<br />
*String is also a class.<br />
*String is used with the main method because the string is immutable and  other thing is that all programming process in the form of string<br />
11, Args is an argument<br />
12, In the next line:<br />
13, The system is a predefined class that provides access to the system<br />
14, Out this, is the output stream  that is connected  to the console<br />
15, We show output by the use of <span className="bold">println()</span> method.<span className="bold"> Println()</span> display the string which is passed to it<br />

      </p>

      <h3 className="mt-4">Java syntax</h3>

      <Card className='inde' border='primary m-4'>
        <Card.Header as="h5">Java syntax Example</Card.Header>
        <Card.Body>

          <Card.Text>
            <p>Access modifier class className<br />
 &#123;<br />
body1<br />
&#125;<br />
            </p>
          </Card.Text>
        </Card.Body>
      </Card>

      <h2 className="mt-4 mh2">
Steps of program in Csharp:</h2>
      <p className="mt-3 para">
        1, Inside text editor  when we create a c# project so after the name of file name use extension and  .cs  is the extensive use for c#<br />
2, A namespace is a logical container of types and the main purpose is to group the items.<br />
3, After using open curly braces .this open curly braces means
They signify that the program is starting and you put all code inside this curly braces<br />
4, The text editor automatically creates class .if your project name is the first program.cs with an extension so by default class name is the first program. And class is also a container means we can store a bunch of code<br />
5, Inside the class, again use curly braces <br />
6, Print this code (static void main(string [] args)) this is also a container.this container uses the main() functions so this means code executed by the main function.<br />
7, If you type any code Inside the open curly braces is executed by a computer but inside the main method<br /><br />
        <span className="bold"> Console.WriteLine(“hello world”);</span> <br /> <br />
8, Console represents the input, output or error<br />
9, WriteLine  means  give the output<br />
10, Console. WriteLine -means is that output the result in the console<br />
11, Console.ReadLine method and is waiting for you to type something<br />
12, And after close all curly braces and program run<br />
      </p>

      <h3 className="mt-4">C# syntax</h3>

      <Card className='inde' border='primary m-4'>
        <Card.Header as="h5">C# Syntax Example</Card.Header>
        <Card.Body>

          <Card.Text>
            <p>namespace syntax<br />
    &#123;<br />
        Access modifier class className<br />
 &#123;<br />
body1<br />
&#125;<br />
&#125;<br />
            </p>
          </Card.Text>
        </Card.Body>
      </Card>

      <h3 className="mt-4">Java Example</h3>

      <Card className='inde' border='primary m-4'>
        <Card.Header as="h5">java Example</Card.Header>
        <Card.Body>

          <Card.Text>
            <p>public class Basic_example&#47;&#47; class is a keyword<br />
 &#123;<br />
 public static void main(String[] args)<br />
&#123;<br />
System.out.println("This is the java simple program");<br />
&#125;<br />
&#125;<br />
            </p>
          </Card.Text>
        </Card.Body>
        <Card.Footer>Output-<br />This is the java simple program</Card.Footer>
      </Card>

      <h3 className="mt-4">C# Example</h3>

      <Card className='inde' border='primary m-4'>
        <Card.Header as="h5">Basic program in c sharp example </Card.Header>
        <Card.Body>
          <Card.Text>
            <p>namespace first<br />
   &#123;<br />
    class Program<br />
    &#123;<br />
        static void Main(string[] args)<br />
        &#123;<br />
            Console.WriteLine("Hello World!");<br />
            &#125;<br />
            &#125;<br />
            &#125;
</p>
          </Card.Text>
        </Card.Body>
        <Card.Footer>Output-<br />Hello World!</Card.Footer>
      </Card>
      <h1 className="mt-5">  </h1>

      <div className="back">

      <a href="/java-vs-csharp-if"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
      </div>


    

    </div>


    
    </div>
  )

}
export default Difference_Bw_Java_and_Csharp